import React from "react";
export default function () {
    return (
        <svg width="200" height="200" viewBox="0 0 200 200">
            <rect x="12" y="68" width="20" height="9" />
            <rect x="5" y="66" width="34" height="2" transform="translate(44 134) rotate(180)" />
        </svg>
    );
}
